/*!
 * CSP-safe jQuery Templates replacement.
 * Replaces jquery.tmpl to avoid new Function() / eval, which violates
 * Content-Security-Policy directives that omit 'unsafe-eval'.
 *
 * Supported syntax (subset used by Kore chatWindow.js):
 *   ${expr}              - interpolate value
 *   {{html expr}}        - interpolate raw HTML
 *   {{if expr}}...{{/if}}
 *   {{if expr}}...{{else}}...{{/if}}
 *   {{if expr}}...{{else otherExpr}}...{{/if}}  (else-if)
 *   {{each(key,val) arrayExpr}}...{{/each}}
 *   {{each arrayExpr}}...{{/each}}
 */
(function ($) {
    'use strict';

    function resolvePath(path, ctx) {
        path = (path || '').trim();
        if (!path) return undefined;
        var re = /([^.\[\]\s]+)|\[(\d+)\]/g, m, val = ctx;
        while ((m = re.exec(path)) !== null) {
            if (val == null) return undefined;
            val = val[m[1] !== undefined ? m[1] : parseInt(m[2], 10)];
        }
        return val;
    }

    function splitTop(str, op) {
        var parts = [], depth = 0, inStr = false, strCh = '', start = 0, L = op.length;
        for (var i = 0; i < str.length; i++) {
            var c = str[i];
            if (inStr) {
                if (c === strCh && str[i - 1] !== '\\') inStr = false;
            } else if (c === '"' || c === "'") {
                inStr = true; strCh = c;
            } else if (c === '(' || c === '[') {
                depth++;
            } else if (c === ')' || c === ']') {
                depth--;
            } else if (depth === 0 && str.slice(i, i + L) === op) {
                parts.push(str.slice(start, i));
                i += L - 1;
                start = i + 1;
            }
        }
        parts.push(str.slice(start));
        return parts;
    }

    function findTopOp(str, op) {
        var depth = 0, inStr = false, strCh = '', L = op.length;
        for (var i = 0; i < str.length; i++) {
            var c = str[i];
            if (inStr) {
                if (c === strCh && str[i - 1] !== '\\') inStr = false;
                continue;
            }
            if (c === '"' || c === "'") { inStr = true; strCh = c; continue; }
            if (c === '(' || c === '[') { depth++; continue; }
            if (c === ')' || c === ']') { depth--; continue; }
            if (depth !== 0) continue;
            if (str.slice(i, i + L) !== op) continue;
            var before = i > 0 ? str[i - 1] : '';
            var after  = str[i + L] || '';
            if (op === '>' && after  === '=') continue;
            if (op === '<' && after  === '=') continue;
            if (op === '-' && i === 0)        continue;
            return i;
        }
        return -1;
    }

    function evalExpr(expr, ctx) {
        expr = (expr || '').trim();
        if (!expr) return undefined;

        if ((expr[0] === '"' || expr[0] === "'") && expr[expr.length - 1] === expr[0])
            return expr.slice(1, -1);

        if (/^-?\d+(\.\d+)?$/.test(expr)) return parseFloat(expr);

        if (expr === 'true')      return true;
        if (expr === 'false')     return false;
        if (expr === 'null')      return null;
        if (expr === 'undefined') return undefined;

        if (expr[0] === '(' && expr[expr.length - 1] === ')')
            return evalExpr(expr.slice(1, -1), ctx);

        if (expr[0] === '!')
            return !evalExpr(expr.slice(1).trim(), ctx);

        var orParts = splitTop(expr, '||');
        if (orParts.length > 1) {
            for (var i = 0; i < orParts.length; i++) {
                var ov = evalExpr(orParts[i], ctx);
                if (ov) return ov;
            }
            return evalExpr(orParts[orParts.length - 1], ctx);
        }

        var andParts = splitTop(expr, '&&');
        if (andParts.length > 1) {
            var last;
            for (var i = 0; i < andParts.length; i++) {
                last = evalExpr(andParts[i], ctx);
                if (!last) return last;
            }
            return last;
        }

        var cmpOps = ['===', '!==', '==', '!=', '>=', '<=', '>', '<'];
        for (var ci = 0; ci < cmpOps.length; ci++) {
            var cop = cmpOps[ci];
            var idx = findTopOp(expr, cop);
            if (idx !== -1) {
                var lv = evalExpr(expr.slice(0, idx), ctx);
                var rv = evalExpr(expr.slice(idx + cop.length), ctx);
                switch (cop) {
                    case '===': return lv === rv;
                    case '!==': return lv !== rv;
                    case '==':  return lv == rv;
                    case '!=':  return lv != rv;
                    case '>=':  return lv >= rv;
                    case '<=':  return lv <= rv;
                    case '>':   return lv >  rv;
                    case '<':   return lv <  rv;
                }
            }
        }

        var subIdx = findTopOp(expr, '-');
        if (subIdx > 0) {
            return evalExpr(expr.slice(0, subIdx), ctx) - evalExpr(expr.slice(subIdx + 1), ctx);
        }

        var fnMatch = expr.match(/^([\w$.]+(?:\[[\d]+\])*(?:\.[\w$]+(?:\[[\d]+\])*)*)\(([\s\S]*)\)$/);
        if (fnMatch) {
            var fnPath = fnMatch[1], argsStr = fnMatch[2];
            var fn = resolvePath(fnPath, ctx);
            if (typeof fn === 'function') {
                var args = splitTop(argsStr, ',').map(function (a) { return evalExpr(a.trim(), ctx); });
                var dotI = fnPath.lastIndexOf('.');
                var fnCtx = dotI >= 0 ? resolvePath(fnPath.slice(0, dotI), ctx) : ctx;
                return fn.apply(fnCtx, args);
            }
            return undefined;
        }

        return resolvePath(expr, ctx);
    }

    function extractBlock(template, start, type) {
        var i = start, depth = 1;
        var segments = [];
        var segStart = start;
        var segCond  = undefined;

        while (i < template.length) {
            var lb = template.indexOf('{{', i);
            if (lb === -1) break;
            var rb = template.indexOf('}}', lb + 2);
            if (rb === -1) break;

            var inner = template.slice(lb + 2, rb).trim();

            var opensNested = (inner === type) ||
                              inner.startsWith(type + ' ') ||
                              inner.startsWith(type + '(');

            if (opensNested) { depth++; i = rb + 2; continue; }

            if (inner === '/' + type) {
                depth--;
                if (depth === 0) {
                    segments.push({ cond: segCond, body: template.slice(segStart, lb) });
                    return {
                        ifBody:         segments[0].body,
                        elseIfClauses:  segments.length > 1 ? segments.slice(1) : null,
                        end:            rb + 2
                    };
                }
                i = rb + 2; continue;
            }

            if (depth === 1 && type === 'if' &&
                (inner === 'else' || inner.startsWith('else ') || inner.startsWith('else\t'))) {
                segments.push({ cond: segCond, body: template.slice(segStart, lb) });
                segCond  = inner === 'else' ? null : inner.slice(4).trim();
                segStart = rb + 2;
                i = rb + 2; continue;
            }

            i = rb + 2;
        }
        return null;
    }

    function processBlock(template, ctx) {
        var result = '', i = 0;

        while (i < template.length) {
            var nd = template.indexOf('{{', i);
            var ns = template.indexOf('${', i);

            if (nd === -1 && ns === -1) { result += template.slice(i); break; }

            var next;
            if      (nd === -1) next = ns;
            else if (ns === -1) next = nd;
            else                next = Math.min(nd, ns);

            result += template.slice(i, next);

            if (next === ns) {
                var se = template.indexOf('}', next + 2);
                if (se === -1) { result += template.slice(next); break; }
                var sVal = evalExpr(template.slice(next + 2, se), ctx);
                result += (sVal != null ? String(sVal) : '');
                i = se + 1;
                continue;
            }

            var te = template.indexOf('}}', next + 2);
            if (te === -1) { result += template.slice(next); break; }
            var tag      = template.slice(next + 2, te).trim();
            var afterTag = te + 2;

            if (tag.startsWith('html ') || tag.startsWith('html\t')) {
                var hVal = evalExpr(tag.slice(5).trim(), ctx);
                result += (hVal != null ? String(hVal) : '');
                i = afterTag; continue;
            }

            if (tag.startsWith('if ') || tag.startsWith('if\t')) {
                var block = extractBlock(template, afterTag, 'if');
                if (!block) { i = afterTag; continue; }
                if (evalExpr(tag.slice(3).trim(), ctx)) {
                    result += processBlock(block.ifBody, ctx);
                } else if (block.elseIfClauses) {
                    for (var ei = 0; ei < block.elseIfClauses.length; ei++) {
                        var clause = block.elseIfClauses[ei];
                        if (clause.cond === null || evalExpr(clause.cond, ctx)) {
                            result += processBlock(clause.body, ctx);
                            break;
                        }
                    }
                }
                i = block.end; continue;
            }

            if (tag.startsWith('each')) {
                var keyVar = '$index', valVar = '$value', arrExpr;
                var eachM = tag.match(/^each\((\w+),\s*(\w+)\)\s+([\s\S]+)$/);
                if (eachM) {
                    keyVar = eachM[1]; valVar = eachM[2]; arrExpr = eachM[3].trim();
                } else {
                    arrExpr = tag.replace(/^each\s+/, '').trim();
                }
                var eBlock = extractBlock(template, afterTag, 'each');
                if (!eBlock) { i = afterTag; continue; }
                var arr = evalExpr(arrExpr, ctx);
                if (arr != null) {
                    var arrKeys = Array.isArray(arr)
                        ? arr.map(function (_, k) { return k; })
                        : Object.keys(arr);
                    for (var ai = 0; ai < arrKeys.length; ai++) {
                        var k = arrKeys[ai];
                        var childCtx = {};
                        for (var ck in ctx) {
                            if (Object.prototype.hasOwnProperty.call(ctx, ck)) childCtx[ck] = ctx[ck];
                        }
                        childCtx[keyVar] = k;
                        childCtx[valVar] = arr[k];
                        result += processBlock(eBlock.ifBody, childCtx);
                    }
                }
                i = eBlock.end; continue;
            }

            result += template.slice(next, afterTag);
            i = afterTag;
        }

        return result;
    }

    function renderTemplate(templateHtml, data) {
        var m = templateHtml.match(/<s(?:cript|cipt)[^>]*>([\s\S]*?)<\/s(?:cript|cipt)>/i);
        var content = m ? m[1] : templateHtml;
        return processBlock(content, data || {});
    }

    $.fn.tmpl = function (data) {
        var html = '';
        this.each(function () { html += $(this).html(); });
        if (!html && this.length === 0) {
            html = $.trim((this.selector || '') + '');
        }
        return $(renderTemplate(html, data));
    };

    $.tmpl = function (template, data) {
        return $(renderTemplate(template, data));
    };

    $.template = function (name, template) {
        if (typeof template === 'string') {
            return { tmpl: function (data) { return $(renderTemplate(template, data)); } };
        }
        return template;
    };

}(jQuery));
